import React, { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import api from '../api/api';

export default function PinConfirmModal({ open, onClose, onVerified }) {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { if (open) { setPin(''); setError(''); } }, [open]);

  const submit = async () => {
    if (!/^[A-Za-z0-9]{4,}$/.test(pin.trim())) return setError('El PIN debe tener al menos 4 caracteres.');
    setLoading(true);
    setError('');
    try {
      const tenantid = localStorage.getItem('tenantid');
      const { data } = await api.post('/auth/pin-login', { pin: pin.trim(), tenantid }, { headers: { TenantId: tenantid } });
      if (!data?.token) throw new Error('La API no devolvió token de autorización.');
      onVerified?.(data);
    } catch (err) {
      setError(err?.response?.data?.message || err?.response?.data?.error || err.message || 'PIN inválido.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Autorización de supervisor</DialogTitle>
      <DialogContent>
        {error ? <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert> : null}
        <TextField fullWidth autoFocus type="password" label="PIN" value={pin} onChange={(e) => setPin(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />
      </DialogContent>
      <DialogActions><Button onClick={onClose} disabled={loading}>Cancelar</Button><Button variant="contained" onClick={submit} disabled={loading}>{loading ? <CircularProgress size={18} color="inherit" /> : 'Autorizar'}</Button></DialogActions>
    </Dialog>
  );
}
